import React from "react";
import classNames from "classnames";
import { MilestoneIcon } from "@common/milestoneIcon";
import { Context } from "@scenes/optimizedGantt/context";
import { isBlocked } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Milestone({
  element,
  constraints,
  isHovered,
  onClick,
  onMouseDown,
  onMouseMove,
  onTouchStart,
  onTouchMove,
}: Props) {
  const { cell } = React.useContext(Context);

  return (
    <div
      className={classNames(styles.milestone, {
        [styles.blocked]: isBlocked(element, constraints),
        [styles.hovered]: isHovered,
      })}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      onMouseMove={onMouseMove}
      onTouchMove={onTouchMove}
    >
      <div className={styles.iconBox}>
        <MilestoneIcon
          className={styles.icon}
          style={{ width: cell.height }}
          milestone={element}
        />
      </div>
    </div>
  );
}

export { Milestone };
